const actionTypes = {

  SIGN_IN_REQUEST: 'SIGN_IN_REQUEST',
  SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',

  //zmena hesla
  UPDATE_PASSWORD_REQUEST: 'UPDATE_PASSWORD_REQUEST',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FAILURE: 'UPDATE_PASSWORD_FAILURE',


  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",

  LOGIN_OAUTH_REQUEST: "LOGIN_OAUTH_REQUEST",
  LOGIN_OAUTH_SUCCESS: "LOGIN_OAUTH_SUCCESS",
  LOGIN_OAUTH_FAILURE: "LOGIN_OAUTH_FAILURE",

  SIGN_OUT: "SIGN_OUT",

  // REGISTER
  CREATE_USER_REQUEST: "CREATE_USER_REQUEST",
  CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
  CREATE_USER_FAILURE: "CREATE_USER_FAILURE",

  // REGISTER OAUTH
  CREATE_USER_OAUTH_REQUEST: "CREATE_USER_OAUTH_REQUEST",
  CREATE_USER_OAUTH_SUCCESS: "CREATE_USER_OAUTH_SUCCESS",
  CREATE_USER_OAUTH_FAILURE: "CREATE_USER_OAUTH_FAILURE",

  // VERIFY
  VERIFY_GUID_REQUEST: "VERIFY_GUID_REQUEST",
  VERIFY_GUID_SUCCESS: "VERIFY_GUID_SUCCESS",
  VERIFY_GUID_FAILURE: "VERIFY_GUID_FAILURE",

  VERIFY_EMAIL_AND_PASS_REQUEST: "VERIFY_EMAIL_AND_PASS_REQUEST",
  VERIFY_EMAIL_AND_PASS_SUCCESS: "VERIFY_EMAIL_AND_PASS_SUCCESS",
  VERIFY_EMAIL_AND_PASS_FAILURE: "VERIFY_EMAIL_AND_PASS_FAILURE",

  UPDATE_USER_REQUEST: "UPDATE_USER_REQUEST",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  UPDATE_USER_FAILURE: "UPDATE_USER_FAILURE",
  REFRESH_USER_REQUEST: "REFRESH_USER_REQUEST",
  REFRESH_USER_SUCCESS: "REFRESH_USER_SUCCESS",
  REFRESH_USER_FAILURE: "REFRESH_USER_FAILURE",

  CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "CHANGE_PASSWORD_FAILURE",

  FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "FORGOT_PASSWORD_FAILURE",

  // GET USER MANUAL
  GET_USER_MANUAL_REQUEST: "GET_USER_MANUAL_REQUEST",
  GET_USER_MANUAL_SUCCESS: "GET_USER_MANUAL_SUCESS",
  GET_USER_MANUAL_FAILURE: "GET_USER_MANUAL_FAILURE",

  // GET ADMIN MANUAL
  GET_ADMIN_MANUAL_REQUEST: "GET_ADMIN_MANUAL_REQUEST",
  GET_ADMIN_MANUAL_SUCCESS: "GET_ADMIN_MANUAL_SUCESS",
  GET_ADMIN_MANUAL_FAILURE: "GET_ADMIN_MANUAL_FAILURE",

  // FILES
  DOWNLOAD_FILE_REQUEST: "DOWNLOAD_FILE_REQUEST",
  DOWNLOAD_FILE_SUCCESS: "DOWNLOAD_FILE_SUCESS",
  DOWNLOAD_FILE_FAILURE: "DOWNLOAD_FILE_FAILURE",

  // REPORTS
  GET_REPORTS_NAMES_REQUEST: "GET_REPORTS_NAMES_REQUEST",
  GET_REPORTS_NAMES_SUCCESS: "GET_REPORTS_NAMES_SUCESS",
  GET_REPORTS_NAMES_FAILURE: "GET_REPORTS_NAMES_FAILURE",

  // MESSAGE
  FAILURE: "FAILURE",
  SHOW_MSG: "SHOW_MSG",
  HIDE_MSG: "HIDE_MSG",

  // APP HEADER
  SHOW_APP_HEADER: "SHOW_APP_HEADER",
  CHANGE_HEADER_TITLE: "CHANGE_HEADER_TITLE",

  // Spravy
  CHANGE_SPRAVA: "CHANGE_SPRAVA",
  UPDATE_CUSTOM_FILTERS_SPRAVA: "UPDATE_CUSTOM_FILTERS_SPRAVA",

  GET_SPRAVA_REQUEST: "GET_SPRAVA_REQUEST",
  GET_SPRAVA_SUCCESS: "GET_SPRAVA_SUCCESS",
  GET_SPRAVA_FAILURE: "GET_SPRAVA_FAILURE",

  GET_LIST_SPRAVA_REQUEST: "GET_LIST_SPRAVA_REQUEST",
  GET_LIST_SPRAVA_SUCCESS: "GET_LIST_SPRAVA_SUCCESS",
  GET_LIST_SPRAVA_FAILURE: "GET_LIST_SPRAVA_FAILURE",

  GET_COUNT_NEPRECITANE_SPRAVY_REQUEST: "GET_COUNT_NEPRECITANE_SPRAVY_REQUEST",
  GET_COUNT_NEPRECITANE_SPRAVY_SUCCESS: "GET_COUNT_NEPRECITANE_SPRAVY_SUCCESS",
  GET_COUNT_NEPRECITANE_SPRAVY_FAILURE: "GET_COUNT_NEPRECITANE_SPRAVY_FAILURE",

  PUT_SPRAVA_REQUEST: "PUT_SPRAVA_REQUEST",
  PUT_SPRAVA_SUCCESS: "PUT_SPRAVA_SUCCESS",
  PUT_SPRAVA_FAILURE: "PUT_SPRAVA_FAILURE",

  // Ulohy
  CHANGE_ULOHA: "CHANGE_ULOHA",

  GET_LIST_ULOHA_REQUEST: "GET_LIST_ULOHA_REQUEST",
  GET_LIST_ULOHA_SUCCESS: "GET_LIST_ULOHA_SUCCESS",
  GET_LIST_ULOHA_FAILURE: "GET_LIST_ULOHA_FAILURE",

  // Vyjadrenie
  VYJADRENIE_SAVE_DATA: "VYJADRENIE_SAVE_DATA",
  CHANGE_VYJADRENIE: "CHANGE_VYJADRENIE",

  CREATE_VYJADRENIE_REQUEST: "CREATE_VYJADRENIE_REQUEST",
  CREATE_VYJADRENIE_SUCCESS: "CREATE_VYJADRENIE_SUCCESS",
  CREATE_VYJADRENIE_FAILURE: "CREATE_VYJADRENIE_FAILURE",

  GET_LIST_VYJADRENIE_REQUEST: "GET_LIST_VYJADRENIE_REQUEST",
  GET_LIST_VYJADRENIE_SUCCESS: "GET_LIST_VYJADRENIE_SUCCESS",
  GET_LIST_VYJADRENIE_FAILURE: "GET_LIST_VYJADRENIE_FAILURE",

  // Ziadost
  ZIADOST_SAVE_DATA: "ZIADOST_SAVE_DATA",
  CHANGE_ZIADOST: "CHANGE_ZIADOST",

  CREATE_ZIADOST_REQUEST: "CREATE_ZIADOST_REQUEST",
  CREATE_ZIADOST_SUCCESS: "CREATE_ZIADOST_SUCCESS",
  CREATE_ZIADOST_FAILURE: "CREATE_ZIADOST_FAILURE",

  GET_MY_LIST_ZIADOST_REQUEST: "GET_MY_LIST_ZIADOST_REQUEST",
  GET_MY_LIST_ZIADOST_SUCCESS: "GET_MY_LIST_ZIADOST_SUCCESS",
  GET_MY_LIST_ZIADOST_FAILURE: "GET_MY_LIST_ZIADOST_FAILURE",

  GET_ALL_LIST_ZIADOST_REQUEST: "GET_ALL_LIST_ZIADOST_REQUEST",
  GET_ALL_LIST_ZIADOST_SUCCESS: "GET_ALL_LIST_ZIADOST_SUCCESS",
  GET_ALL_LIST_ZIADOST_FAILURE: "GET_ALL_LIST_ZIADOST_FAILURE",

  // Mapa
  CHANGE_MAPA_IMAGE: "CHANGE_MAPA_IMAGE",
  GET_MAPA_IMAGE_REQUEST: "GET_MAPA_IMAGE_REQUEST",
  GET_MAPA_IMAGE_SUCCESS: "GET_MAPA_IMAGE_SUCCESS",
  GET_MAPA_IMAGE_FAILURE: "GET_MAPA_IMAGE_FAILURE",

  CHANGE_MAPA_EXTENT_COORDS: "CHANGE_MAPA_EXTENT_COORDS",
  GET_MAPA_EXTENT_COORDS_REQUEST: "GET_MAPA_EXTENT_COORDS_REQUEST",
  GET_MAPA_EXTENT_COORDS_SUCCESS: "GET_MAPA_EXTENT_COORDS_SUCCESS",
  GET_MAPA_EXTENT_COORDS_FAILURE: "GET_MAPA_EXTENT_COORDS_FAILURE",

  GET_MAPA_URL_REQUEST: "GET_MAPA_URL_REQUEST",
  GET_MAPA_URL_SUCCESS: "GET_MAPA_URL_SUCCESS",
  GET_MAPA_URL_FAILURE: "GET_MAPA_URL_FAILURE",

  GET_GOOGLE_MAP_LAT_LNG_REQUEST: "GET_GOOGLE_MAP_LAT_LNG_REQUEST",
  GET_GOOGLE_MAP_LAT_LNG_SUCCESS: "GET_GOOGLE_MAP_LAT_LNG_SUCCESS",
  GET_GOOGLE_MAP_LAT_LNG_FAILURE: "GET_GOOGLE_MAP_LAT_LNG_FAILURE",

  // Tabulky
  GET_AA_DEF_OB_HODN_REQUEST: "GET_AA_DEF_OB_HODN_REQUEST",
  GET_AA_DEF_OB_HODN_SUCCESS: "GET_AA_DEF_OB_HODN_SUCCESS",
  GET_AA_DEF_OB_HODN_FAILURE: "GET_AA_DEF_OB_HODN_FAILURE",

  // Ciselniky
  CHANGE_DOVOD: "CHANGE_DOVOD",
  GET_ZP_C_DOVOD_REQUEST: "GET_ZP_C_DOVOD_REQUEST",
  GET_ZP_C_DOVOD_SUCCESS: "GET_ZP_C_DOVOD_SUCCESS",
  GET_ZP_C_DOVOD_FAILURE: "GET_ZP_C_DOVOD_FAILURE",

  CHANGE_PRIORITA: "CHANGE_PRIORITA",
  GET_ZP_C_PRIORITA_REQUEST: "GET_ZP_C_PRIORITA_REQUEST",
  GET_ZP_C_PRIORITA_SUCCESS: "GET_ZP_C_PRIORITA_SUCCESS",
  GET_ZP_C_PRIORITA_FAILURE: "GET_ZP_C_PRIORITA_FAILURE",

  CHANGE_TYP_PRACE: "CHANGE_TYP_PRACE",
  GET_ZP_C_TYP_PRACE_REQUEST: "GET_ZP_C_TYP_PRACE_REQUEST",
  GET_ZP_C_TYP_PRACE_SUCCESS: "GET_ZP_C_TYP_PRACE_SUCCESS",
  GET_ZP_C_TYP_PRACE_FAILURE: "GET_ZP_C_TYP_PRACE_FAILURE",

  CHANGE_STAV_ZIADOSTI: "CHANGE_STAV_ZIADOSTI",
  GET_ZP_C_STAV_ZIADOSTI_REQUEST: "GET_ZP_C_STAV_ZIADOSTI_REQUEST",
  GET_ZP_C_STAV_ZIADOSTI_SUCCESS: "GET_ZP_C_STAV_ZIADOSTI_SUCCESS",
  GET_ZP_C_STAV_ZIADOSTI_FAILURE: "GET_ZP_C_STAV_ZIADOSTI_FAILURE",

  CHANGE_VYSLEDOK_VYJADRENIA: "CHANGE_VYSLEDOK_VYJADRENIA",
  GET_ZP_C_VYSLEDOK_VYJADRENIA_REQUEST: "GET_ZP_C_VYSLEDOK_VYJADRENIA_REQUEST",
  GET_ZP_C_VYSLEDOK_VYJADRENIA_SUCCESS: "GET_ZP_C_VYSLEDOK_VYJADRENIA_SUCCESS",
  GET_ZP_C_VYSLEDOK_VYJADRENIA_FAILURE: "GET_ZP_C_VYSLEDOK_VYJADRENIA_FAILURE",
};

export default actionTypes;
